<template>
  <div class="row">
    <div class="col-2">
      <button class="btn btn-secondary button" @click="sort">
        To original order
      </button>
    </div>
    

    <div class="col-6">
      <h3>Transition</h3>
      <draggable
        class="list-group"
        tag="ul"
        v-model="list"
        v-bind="dragOptions"
        group="list"
        @start="drag = true"
        @end="drag = false"
        handle=".handle"
      >
          <li
            v-for="element in list"
            :key="element.order"
          >
            <span class="list-group-item handle">拖</span>
            一级{{ element.name }}
            <draggable
              class="list-group"
              tag="ul1"
              v-model="list1"
              :group="element.name"
              v-bind="dragOptions1"
              @start="drag = true"
              @end="drag = false"
              handle=".handle"
            >
              <li
                v-for="element in list1"
                :key="element.order"
              >
                <span class="list-group-item handle">拖拖</span>
                二级二级二级{{ element.name }}
                <draggable
                  class="list-group"
                  tag="ul1"
                  v-model="list3"
                  :group="element.name"
                  v-bind="dragOptions3"
                  @start="drag = true"
                  @end="drag = false"
                  handle=".handle"
                >
                  <li
                    v-for="element1 in list3"
                    :key="element1.order"
                  >
                    <span class="list-group-item handle">拖拖拖</span>
                    三级{{ element1.name }}
                  </li>
                </draggable>
              <br/>
              </li>
            </draggable>
            <br/>
          </li>
      </draggable>
    </div>

    <rawDisplayer class="col-3" :value="list" title="List" />
  </div>
</template>

<script>
import draggable from "./../../../core/vuedraggable.js";
// groupId: "5c8083a30f0445acb02514ced98c1ae8"
// researchId: "c9bb2e0c90a74e04bd8e983f7ee6b242"


const message = [
  "vue.draggable",
  "draggable",
  "component",
  "for",
  "vue.js 2.0",
  "based",
  "on",
  "Sortablejs"
];

const message1 = [
  "11",
  "22",
  "33",
  "44",
  "111",
  "55",
  "66",
  "77"
];

const message3 = [
  "vue.55",
  "22",
  "11",
  "44",
  "77",
  "66",
  "88",
  "99"
];

export default {
  name: "transition-example-2",
  display: "Transitions",
  order: 7,
  components: {
    draggable
  },
  data() {
    return {
      list: message.map((name, index) => {
        return { name, order: index + 1 };
      }),
      list1: message1.map((name, index) => {
        return { name, order: index + 1 };
      }),
      list3: message3.map((name, index) => {
        return { name, order: index + 1 };
      }),
      drag: false
    };
  },
  methods: {
    sort() {
      this.list = this.list.sort((a, b) => a.order - b.order);
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    dragOptions1() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    dragOptions3() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  }
};
</script>

<style>
.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
</style>
